import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const FloatingProjectCard = ({ project, index, isActive, onHover, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    onClick(project);
    if (project?.route) {
      navigate(project?.route);
    }
  };

  const cardStyle = {
    transform: `
      translateX(${Math.cos((index * Math.PI * 2) / 6 + Date.now() * 0.001) * 200}px)
      translateY(${Math.sin((index * Math.PI * 2) / 6 + Date.now() * 0.001) * 150}px)
      rotateY(${isHovered ? 15 : 0}deg)
      scale(${isActive || isHovered ? 1.1 : 1})
    `,
    animationDelay: `${index * 0.2}s`
  };

  return (
    <div
      className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all duration-500 ${
        isActive ? 'z-20' : 'z-10'
      }`}
      style={cardStyle}
      onMouseEnter={() => {
        setIsHovered(true);
        onHover(project);
      }}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className={`glass-panel rounded-xl p-6 w-80 h-64 transform-3d transition-all duration-300 ${
        isActive || isHovered ? 'cosmic-glow' : ''
      }`}>
        {/* Project Image */}
        <div className="relative h-32 mb-4 rounded-lg overflow-hidden">
          <Image
            src={project?.image}
            alt={project?.title}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent"></div>
          
          {/* Category Badge */}
          <div className="absolute top-3 right-3">
            <span className="px-3 py-1 bg-accent/20 text-accent text-xs font-medium rounded-full border border-accent/30">
              {project?.category}
            </span>
          </div>
        </div>

        {/* Project Info */}
        <div className="space-y-2">
          <h3 className="font-headline font-bold text-lg text-foreground line-clamp-1">
            {project?.title}
          </h3>
          <p className="font-body text-sm text-muted-foreground line-clamp-2">
            {project?.description}
          </p>
          
          {/* Tech Stack */}
          <div className="flex flex-wrap gap-1 mt-3">
            {project?.technologies?.slice(0, 3)?.map((tech, techIndex) => (
              <span
                key={techIndex}
                className="px-2 py-1 bg-surface/50 text-xs text-foreground rounded border border-border/30"
              >
                {tech}
              </span>
            ))}
            {project?.technologies?.length > 3 && (
              <span className="px-2 py-1 bg-surface/50 text-xs text-muted-foreground rounded border border-border/30">
                +{project?.technologies?.length - 3}
              </span>
            )}
          </div>
        </div>

        {/* Hover Overlay */}
        {(isHovered || isActive) && (
          <div className="absolute inset-0 bg-accent/10 rounded-xl flex items-center justify-center backdrop-blur-sm">
            <div className="text-center">
              <Icon name="Eye" size={32} className="text-accent mx-auto mb-2" />
              <p className="font-body font-medium text-accent">Explore Project</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FloatingProjectCard;